function isAndroid() {
  return /android/i.test(navigator.userAgent.toLowerCase());
}

function updateWhatsAppLinks() {
  // Only convert links if on Android device
  if (!isAndroid()) return;

  const whatsappLinks = document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp"]');

  whatsappLinks.forEach(link => {
    const originalUrl = new URL(link.href);
    let phoneNumber = '';
    let textMessage = '';

    if (originalUrl.hostname.includes('wa.me')) {
      phoneNumber = originalUrl.pathname.replace('/', '');
      textMessage = originalUrl.searchParams.get('text') || '';
    } else if (originalUrl.hostname.includes('api.whatsapp')) {
      phoneNumber = originalUrl.searchParams.get('phone') || '';
      textMessage = originalUrl.searchParams.get('text') || '';
    }

    // Convert only for Android devices
    const newUrl = `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(textMessage)}`;
    link.href = newUrl;
  });
}

document.addEventListener('DOMContentLoaded', updateWhatsAppLinks);
